import { useEffect, useState } from "react";
import { fetchLocationMenu } from "../services/publicApi";

export function useLocationMenu(locationSlug) {
  const [menuData, setMenuData] = useState(null);
  const [loading, setLoading] = useState(Boolean(locationSlug));
  const [error, setError] = useState("");

  useEffect(() => {
    if (!locationSlug) {
      setMenuData(null);
      setLoading(false);
      return undefined;
    }

    let isMounted = true;
    setLoading(true);

    async function loadMenu() {
      try {
        const data = await fetchLocationMenu(locationSlug);

        if (isMounted) {
          setMenuData(data);
          setError("");
        }
      } catch (requestError) {
        if (isMounted) {
          setMenuData(null);
          setError("We could not load this menu right now.");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    loadMenu();

    return () => {
      isMounted = false;
    };
  }, [locationSlug]);

  return { menuData, loading, error };
}